module.exports = __webpack_public_path__ + "image/xhs-account.png";